'use client';

import { useEffect, useRef } from 'react';
import { initSync, isSyncReady, onSyncEvent } from '@/shared/services/syncService';

/**
 * Hook to initialize cloud sync on app startup.
 * Call once in a top-level layout or provider.
 */
export function useCloudSync() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;

    // Only init if user is authenticated
    const hasToken = typeof window !== 'undefined' && !!localStorage.getItem('accessToken');
    if (!hasToken) return;

    initialized.current = true;
    initSync();

    const unsub = onSyncEvent((event) => {
      if (event === 'pull_complete' && typeof window !== 'undefined') {
        // Dispatch a custom event so components can refresh if needed
        window.dispatchEvent(new CustomEvent('sync:pull_complete'));
      }
    });

    return () => {
      unsub();
    };
  }, []);

  return { isSyncReady: isSyncReady() };
}
